import styled from '../ThemeContext'

export const Footer = styled.div``

export const FooterText = styled.span`
  display: inline-block;
  font-weight: 500;
  font-size: 12px;
  color: hsla(0, 0%, 100%, 0.6);
  letter-spacing: 0;
`

export const FooterIcon = styled.img`
  margin-right: 10px;
  height: 18px;
  width: 18px;
  object-fit: contain;
  float: left;
  border-radius: 2.45px;
`



// WEBPACK FOOTER //
// ./src/components/Messages/Message/Embed/elements/footer.ts